import MultiselectField from './MultiselectField';

export default MultiselectField;
